import React from 'react';
import { Link } from 'react-router-dom';

const CallToAction = () => {
    return (
        <section className="w-full bg-[#F2F2F2] py-20 px-4 md:px-8 flex items-center justify-center min-h-[488px]">
            <div className="max-w-[1054px] w-full flex flex-col items-center text-center gap-[50px]">

                {/* Text Content Box */}
                <div className="flex flex-col gap-[16px] max-w-[1054px]">
                    <h2 className="font-oswald font-bold text-[32px] md:text-[52px] leading-[1.35] uppercase text-[#070E21]">
                        READY TO MODERNISE YOUR FIXED INCOME <br className="hidden md:block" />
                        TRADING & OPERATIONS?
                    </h2>
                    <p className="font-inter font-normal text-[16px] md:text-[20px] leading-[28px] text-[#070E21]">
                        See how FGC TMS can bring clarity and control to your fixed-income trade lifecycle.
                    </p>
                </div>

                {/* Button */}
                <Link
                    to="/schedule-demo"
                    className="bg-[#00C2FF] hover:bg-[#00a0d6] text-white font-bold rounded-[16px] border border-transparent transition-colors shadow-sm inline-block text-center"
                    style={{
                        padding: '10px 40px',
                        fontSize: '18px', // Approximate size for button text logic
                    }}
                >
                    Request a demo
                </Link>
            </div>
        </section>
    );
};

export default CallToAction;
